var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "ma-0 pa-0", attrs: { width: "100%" } },
    [
      _c(
        "v-card",
        {
          staticClass: "ma-0 pa-2 d-none",
          attrs: { width: "100%", outlined: "" },
        },
        [
          _c(
            "v-slide-group",
            {
              attrs: { multiple: "", "show-arrows": "" },
              model: {
                value: _vm.model,
                callback: function ($$v) {
                  _vm.model = $$v
                },
                expression: "model",
              },
            },
            _vm._l(_vm.folders, function (n) {
              return _c(
                "v-slide-item",
                { key: n.uid },
                [
                  n.name != "add"
                    ? _c(
                        "v-card",
                        {
                          staticClass: "ml-2",
                          attrs: { width: "150px", elevation: "0" },
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              attrs: {
                                outlined: "",
                                color: _vm.isSelectedFolder(n.uid)
                                  ? "transparent"
                                  : "gray",
                                rounded: "",
                              },
                            },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass:
                                    "d-flex align-center justify-center ma-0 pa-0",
                                  class: !_vm.isSelectedFolder(n.uid)
                                    ? "black--text"
                                    : "white--text",
                                  attrs: {
                                    elevation: "0",
                                    color: _vm.isSelectedFolder(n.uid)
                                      ? "blue"
                                      : "white",
                                    outlined: "",
                                  },
                                },
                                [_vm._v(" " + _vm._s(n.name) + " ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-card",
                            {
                              staticClass: "d-flex align-top pl-1 pr-1 mt-1",
                              attrs: { elevation: "0", outlined: "" },
                            },
                            [
                              _c("v-checkbox", {
                                staticClass: "ma-0 pa-0",
                                staticStyle: { "margin-top": "2px!important" },
                                attrs: { dense: "", "hide-details": "" },
                                on: {
                                  change: function ($event) {
                                    return _vm.filterMedia()
                                  },
                                },
                                model: {
                                  value: _vm.selectedFolder[n.uid],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.selectedFolder, n.uid, $$v)
                                  },
                                  expression: "selectedFolder[n.uid]",
                                },
                              }),
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    color: "green",
                                    elevation: "0",
                                    small: "",
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("mdi-pencil"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "v-card",
                        {
                          staticClass:
                            "d-flex align-center justify-center ml-2",
                          attrs: {
                            color: "green",
                            width: "40px",
                            elevation: "0",
                          },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                color: "white",
                                elevation: "0",
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-plus")])],
                            1
                          ),
                        ],
                        1
                      ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        {
          staticClass: "ma-0 pa-2 mt-2",
          attrs: { width: "100%", outlined: "" },
        },
        [
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0" },
            [
              _c("v-data-table", {
                staticStyle: { width: "100%" },
                attrs: {
                  "fixed-header": "",
                  items: _vm.configs,
                  headers: _vm.headers,
                  "hide-default-footer": "",
                  "disable-pagination": "",
                  "show-group-by": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.group",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-btn",
                          {
                            staticClass: "orange--text subtitle-2",
                            attrs: {
                              outlined: "",
                              small: "",
                              disabled: !_vm.ifCanEditNameConfig(),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onPressName(item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.group) + "*")]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.marker",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-btn",
                          {
                            staticClass: "orange--text subtitle-2",
                            attrs: { outlined: "", small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.onPressMarker(item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.marker))]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.meta.updated",
                    fn: function ({ item }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("formatDate")(_vm.getUpdated(item))) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.meta.uid",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-card-text",
                          { staticClass: "blue--text subtitle-2 ma-0 pa-0" },
                          [_vm._v(_vm._s(_vm.getOwner(item)))]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.actions",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "", "max-width": "50%" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: {
                                                icon: "",
                                                color: "orange",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPressInfo(item)
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "22" } },
                                            [_vm._v("mdi-information")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  item.info?.length > 0 ? item.info : "no info"
                                )
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-0 ma-0 pa-0",
                                              attrs: {
                                                disabled:
                                                  !_vm.ifCanEditConfig(),
                                                icon: "",
                                                color: "green",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPressEdit(item)
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "20" } },
                                            [_vm._v("mdi-pencil")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Edit")])]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-0 ma-0 pa-0",
                                              attrs: {
                                                disabled:
                                                  !_vm.ifCanDeleteConfig(),
                                                icon: "",
                                                color: "red",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPressDelete(item)
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "20" } },
                                            [_vm._v("mdi-delete")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Delete")])]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-1 ma-0 pa-0",
                                              attrs: {
                                                disabled:
                                                  !_vm.ifCanDublicateConfig(),
                                                icon: "",
                                                color: "teal lighten-1",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPressDuplicate(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "22" } },
                                            [_vm._v("mdi-content-copy")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Dublicate")])]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-1 ma-0 pa-0",
                                              attrs: {
                                                icon: "",
                                                color: "blue",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPressMergeAndDeploy(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "22" } },
                                            [_vm._v("mdi-merge")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Merge and deploy")])]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-0 ma-0 pa-0",
                                              attrs: {
                                                icon: "",
                                                color: "blue",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPressExportItem(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "20" } },
                                            [_vm._v("mdi-download")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Export to Json")])]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-0 ma-0 pa-0",
                                              attrs: {
                                                icon: "",
                                                color: "blue",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPressImportItem(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "20" } },
                                            [_vm._v("mdi-upload")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Import a config.json")])]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }